import {
  SET_READER_CONNECTION,
  SET_SDK_CONNECTION,
  SET_SDK_REGISTERATION,
  SET_KEY_MODEL,
  SET_KEY_MULTITASK,
  SET_PAD_CONNECTION,
  SET_FACTORY_AVAILABLE,
} from '../constants/SDKConstants';

const initialState = {
  reader: {
    connection: false,
  },
  sdk: {
    connection: false,
    registration: false,
  },

  // TODO: WM、HM分别使用的发卡器和钥匙目前都是上面的reader状态，
  // 严格来说HM应使用reader状态，WM应使用key状态

  // 后期需要统一一下，暂时key属性单独管理WM的设备型号
  key: {
    // model暂时没有实际作用了，本来用于判断是否是多任务钥匙，由于硬件端设计问题，现在使用multiTask属性判断；
    model: null,
    multiTask: false,
  },

  pad: {
    connection: false,
  },

  // 工厂模式是否启动
  factory: {
    available: false,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_READER_CONNECTION: {
      // return {
      //     ...state,
      //     reader: {
      //         ...state.reader,
      //         connection: action.payload
      //     }
      // }
      // 直接对原state，进行更改，这时候state的引用地址并没有发生变化，redux会默认为数据没有更新，从而界面不会刷新
      // return Object.assign(state, { reader: { connection: action.payload } })
      // 需要返回一个新的对象（引用），使用Object.assign可以这样写:
      return Object.assign({}, state, { reader: { connection: action.payload } }); // 官方示例写法
      // 也可以这样写
      // return {...state, ...{reader : { connection : action.payload}} };
    }

    case SET_SDK_CONNECTION: {
      return {
        ...state,
        sdk: Object.assign({}, state.sdk, { connection: action.payload }),
      };
    }

    case SET_SDK_REGISTERATION: {
      return {
        ...state,
        sdk: {
          ...state.sdk,
          registration: action.payload,
        },
      };
    }

    case SET_KEY_MODEL: {
      return {
        ...state,
        key: {
          ...state.key,
          model: action.payload,
        },
      };
    }

    case SET_KEY_MULTITASK: {
      return {
        ...state,
        key: {
          ...state.key,
          multiTask: action.payload,
        },
      };
    }

    case SET_PAD_CONNECTION: {
      return {
        ...state,
        pad: {
          connection: action.payload,
        },
      };
    }

    case SET_FACTORY_AVAILABLE: {
      return {
        ...state,
        factory: {
          available: action.payload,
        },
      };
    }

    default:
      return state;
  }
}
